export const TOGGLE_DRAWER_SUCCESS = 'TOGGLE_DRAWER_SUCCESS'
